import { CheckmarkFilledIcon } from '@calizahq/react-components-v2'
import clsx from 'clsx'
import React, { forwardRef, useEffect } from 'react'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  indeterminate?: boolean
  name: string
}

const useCombinedRefs = (...refs: any[]): React.MutableRefObject<any> => {
  const targetRef = React.useRef<any>(null)

  React.useEffect(() => {
    refs.forEach((ref) => {
      if (!ref) return

      if (typeof ref === 'function') {
        ref(targetRef.current)
      } else {
        ref.current = targetRef.current
      }
    })
  }, [refs])

  return targetRef
}

// eslint-disable-next-line react/display-name
const IndeterminateCheckbox = forwardRef<HTMLInputElement, Props>(
  ({ indeterminate, checked, ...rest }, ref: React.Ref<HTMLInputElement>) => {
    const defaultRef = React.useRef(null)
    const combinedRef = useCombinedRefs(ref, defaultRef)

    useEffect(() => {
      if (combinedRef?.current) {
        combinedRef.current.indeterminate = indeterminate ?? false
      }
    }, [combinedRef, indeterminate])

    return (
      <div
        className={clsx(
          'relative cursor-pointer w-5 h-5 rounded flex items-center justify-center border-2',
          checked
            ? 'bg-action-primary border-action-primary'
            : 'bg-primary border-on-media',
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <input
          checked={checked}
          className="cursor-pointer absolute left-0 w-full h-full top-0 opacity-0 z-10"
          ref={combinedRef}
          type="checkbox"
          {...rest}
        />
        {checked && (
          <CheckmarkFilledIcon
            className="text-white w-3 h-3 pointer-events-none"
          />
        )}
      </div>
    )
  },
)

export default IndeterminateCheckbox
